import React, { useEffect } from "react";
import { getdepartmentData } from "../../../redux/actions/dataAction";
import { connect } from "react-redux";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";

const Department = (props) => {
  useEffect(() => {
    props.getdepartmentData();
  }, []);
  const columns = [
    // {title:'Chairman',field:'chairman'},
    { title: "Created By", field: "created_by" },
    { title: "Description", field: "description" },
    { title: "Name", field: "name" },
    { title: "Journals", field: "no_of_journals" },
    { title: "Magazines", field: "no_of_magazines" },
    { title: "Professional", field: "professional_bodies" },
    { title: "Short Name", field: "short_name" },
    { title: "Established", field: "year_of_establishment" },
  ];
  return (
    <div className="customContainer mb-5">
      <CustomHeading title="Department" />
      <CustomTableWithAll
        data={props.department.data}
        buttonRequired={true}
        buttonLabel="ADD"
        columns={columns}
        api="/api/department/"
        identify="Department"
        title={"All Departments"}
      />
    </div>
  );
};

const mapActionWithProps = {
  getdepartmentData,
};

const mapStateWithProps = (state) => ({
  department: state.data.department,
});
export default connect(mapStateWithProps, mapActionWithProps)(Department);
